import React from "react";
import { INFO_TITLE } from "../../util/constants";
import { Grid, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SlideUpTransition from "./SlideUpTransition";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { BID_TYPE } from "../../util/bid/bidConstants";
import FreedayBidPDFExport from "../../pages/bid/FreedayBidPDFExport";
import IAMFTOBidPDFExport from "../../pages/bid/IAMFTOBidPDFExport";
import TWUDATFTOBidPDFExport from "../../pages/bid/TWUDATFTOBidPDFExport";
import IAMDATBidPDFExport from "../../pages/bid/IAMDATBidPDFExport";
import NCBidPDFExport from "../../pages/bid/NCBidPDFExport";

const BidInfoDialog = (props) => {
  const renderPDFExportButton = () => {
    if (props.bidType === BID_TYPE.FREEDAY) {
      return <FreedayBidPDFExport bidChoiceData={props.bidChoiceData} buttonVariant="contained" />;
    } else if (props.bidType === BID_TYPE.FTO) {
      return <IAMFTOBidPDFExport bidChoiceData={props.bidChoiceData} buttonVariant="contained" />;
    } else if (props.bidType === BID_TYPE.TWU_DAT_FTO) {
      return <TWUDATFTOBidPDFExport bidChoiceData={props.bidChoiceData} buttonVariant="contained" />;
    } else if (props.bidType === BID_TYPE.IAM_DAT) {
      return <IAMDATBidPDFExport bidChoiceData={props.bidChoiceData} buttonVariant="contained" />;
    } else if (props.bidType === BID_TYPE.NC_PTO_FTO) {
      return <NCBidPDFExport bidChoiceData={props.bidChoiceData} buttonVariant="contained" />;
    } else if (props.bidType === BID_TYPE.NC_PTO_GOC_HOL) {
      return <NCBidPDFExport bidChoiceData={props.bidChoiceData} buttonVariant="contained" />;
    } else {
      return <></>;
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "600px",
          maxWidth: "90vw",
          margin: "auto",
          whiteSpace: "pre-line",
        },
      }}
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      data-testid="info-dialog"
    >
      <DialogTitle>{props.title ? props.title : INFO_TITLE}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleCloseClicked}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          paddingTop: 0,
        }}
      >
        <DialogContentText component={"div"}>
          <ol>
            {(props.bidType === BID_TYPE.TWU_DAT_FTO || props.bidType === BID_TYPE.IAM_DAT) && (
              <li>
                Enter the <b>number of DATs</b> you want to use (0-25).
              </li>
            )}
            {(props.bidType === BID_TYPE.NC_PTO_FTO || props.bidType === BID_TYPE.NC_PTO_GOC_HOL) && (
              <li>
                Enter the <b>number of PTOs</b> you want to use (0-31).
              </li>
            )}
            {props.bidType === BID_TYPE.NC_PTO_GOC_HOL && (
              <li>
                Enter the <b>number of GOC-HOLs</b> you want to use (0-8).
              </li>
            )}
            {(props.bidType === BID_TYPE.FTO ||
              props.bidType === BID_TYPE.TWU_DAT_FTO ||
              props.bidType === BID_TYPE.NC_PTO_FTO) && (
              <li>
                Enter the <b>number of FTOs</b> you want to use (0-10).
              </li>
            )}
            <li>
              Tap/Click on the <b>Select Date</b> field to pick a date as your choice.
            </li>
            {props.bidType === BID_TYPE.TWU_DAT_FTO && (
              <li>
                Tap/Click on the <b>Select Time Off Type</b> field to designate your choice as a DAT or FTO.
              </li>
            )}
            {props.bidType === BID_TYPE.NC_PTO_FTO && (
              <li>
                Tap/Click on the <b>Select Time Off Type</b> field to designate your choice as a PTO or FTO.
              </li>
            )}
            {props.bidType === BID_TYPE.NC_PTO_GOC_HOL && (
              <li>
                Tap/Click on the <b>Select Time Off Type</b> field to designate your choice as a PTO or GOC-HOL.
              </li>
            )}
            <li style={{ paddingTop: "10px" }}>
              Tap/Click <b>ADD ANOTHER CHOICE</b> to include additional choices.
            </li>
            <li style={{ paddingTop: "10px" }}>
              Use the <ArrowCircleUpIcon fontSize="small" style={{ display: "inline", verticalAlign: "middle" }} />
              <ArrowCircleDownIcon fontSize="small" style={{ display: "inline", verticalAlign: "middle" }} /> arrows to
              reorder your choices.
            </li>
          </ol>
          {!props.isDesktopView && (
            <Grid container alignItems={"center"} justifyContent={"center"} marginTop={"15px"}>
              {renderPDFExportButton()}
            </Grid>
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

BidInfoDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  handleCloseClicked: PropTypes.func,
  isDesktopView: PropTypes.bool,
  bidType: PropTypes.string,
  bidChoiceData: PropTypes.object,
};

export default BidInfoDialog;
